module.exports = __webpack_public_path__ + "d068d76bae18810bf9adb9fd1c1ecac7.jpg";